<template>
  <common-dialog
    ref="dialog"
    ok-text="Print"
    :save-cb="printPdf"
    class="dialog"
  >
    <template v-slot:content>
      <div class="labels">
        <div class="number-container label">
          <h1 class="number">{{ slot.no }}</h1>
        </div>
        <div class="label">
          <div class="graphs">
            <div class="qr-code">
              <img :src="src" />
            </div>
            <div class="position-graph"  v-if="stack.type === 'Stack'">
              <div
                class="section"
                v-for="sectionIndex in sectionNum"
                :key="'section-' + sectionIndex"
                :style="aveHeight"
              >
                <div
                  class="slot"
                  :class="{
                    'occupied-slot':
                      stack.slots[
                        (sectionIndex - 1) * slotPerSection + slotIndex - 1
                      ].no === slot.no
                  }"
                  v-for="slotIndex in slotPerSection"
                  :key="'section-' + sectionIndex + '-slot-' + slotIndex"
                  :style="aveWidth"
                >
                </div>
              </div>
            </div>
          </div>
          <div class="tips-container"  v-if="stack.type === 'Stack'">
            <div></div>
            <div class="tip">Left --> Right</div>
          </div>
        </div>
      </div>
    </template>
  </common-dialog>
</template>

<script>
// components
import CommonDialog from '@/components/common/CommonDialog'
// utils
import { downloadPdf } from '@/core/utils/pdf'

const QRCode = require('qrcode')

export default {
  name: 'SlotLabelDialog',
  components: {
    CommonDialog
  },
  props: {},
  data() {
    return {
      slot: {},
      stack: {},
      src: ''
    }
  },
  methods: {
    open(slot, stack) {
      this.$set(this, 'slot', slot)
      this.$set(this, 'stack', stack)
      this.getSrc(slot)
      this.$refs.dialog.open()
    },
    async getSrc(slot) {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'Slot',
          id: slot.id,
          no: slot.no
        }),
        {
          margin: 0,
          width: 200,
          height: 200
        }
      )
      this.$set(this, 'src', src)
    },
    printPdf() {
      this.getPdf('.label', 'small label', 'l').then(e => {
        const pdf = e
        downloadPdf(pdf, 11)
      })
      return [true, '']
    }
  },
  computed: {
    sectionNum() {
      return this.stack.sectionNum
    },
    slotPerSection() {
      return this.stack.slotPerSection
    },
    aveHeight() {
      return `height: calc(100% / ${this.sectionNum})`
    },
    aveWidth() {
      return `width: calc(100% / ${this.slotPerSection})`
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

::v-deep .el-dialog__body {
  @extend .f-c-c-c;

  .labels {
    @extend .f-c;

    gap: 10px;

    .label {
      //   border: solid;
    }

    .number-container {
      @extend .f-c;

      align-items: center;
      justify-content: start;
      width: 400px;
      height: 250px;
      font-size: 40px;
      color: #000;

      .number {
        width: fit-content;
      }

      h1 {
        margin: 0;
      }
    }

    .graphs {
      @extend .f-r-vc;

      gap: 20px;
      justify-content: space-evenly;
      width: 400px;
      height: 200px;

      .qr-code {
        margin-top: 5px;
      }

      .position-graph {
        @extend .f-c;

        justify-content: space-evenly;
        gap: 0;
        height: 200px;
        width: 200px;
        color: #000;
        border: solid 1.5px;

        .section {
          @extend .f-r;

          justify-content: space-evenly;
          gap: 0;
          flex-grow: 1;

          .slot {
            @extend .f-c-c-c;

            flex-grow: 1;
            box-sizing: border-box;
            border: solid;

            .op-icon {
              font-size: 40px;
            }
          }

          .occupied-slot {
            background-color: #000;
          }
        }
      }
    }
  }
}

.tips-container {
  @extend .f-r-vc;

  justify-content: space-around;
  color: #000;
  font-weight: bold;
}
</style>
